<template>
  <vs-row v-if="data">
    <vs-col vs-w="6" class="p-3">
      <mental-health-category-card :data="data" :category="'ENERGY'" :max-value="100" :formatter="energyFormatter"/>
    </vs-col>
    <vs-col vs-w="6" class="p-3">
      <mental-health-category-card :data="data" :category="'STRESS'" :max-value="100" :formatter="energyFormatter"/>
    </vs-col>
    <vs-col vs-w="6" class="p-3">
      <mental-health-category-card :data="data" :category="'DEPRESSION'" :max-value="27"/>
    </vs-col>
    <vs-col vs-w="6" class="p-3">
      <mental-health-category-card :data="data" :category="'ANXIETY'" :max-value="21"/>
    </vs-col>

    <vs-col vs-w="6" class="p-3">
      <mental-health-top-stressor-card :data="data"/>
    </vs-col>
    <vs-col vs-w="6" class="p-3">
      <mental-health-top-stressor-cause-card :data="data"/>
    </vs-col>
    <vs-col vs-w="12" class="p-3">
      <mental-health-why-joined-card :data="data"/>
    </vs-col>
  </vs-row>
</template>

<script>
import MentalHealthCategoryCard from './graphs/mental-health-category-card';
import MentalHealthWhyJoinedCard from './graphs/mental-health-why-joined-card';
import MentalHealthStressorsCard from './graphs/mental-health-stressors-card';
import MentalHealthTopStressorCard from './graphs/mental-health-top-stressor-card';
import MentalHealthTopStressorCauseCard from './graphs/mental-health-top-stressor-cause-card';
import {ResourceImpl} from 'hal-client';
import Vue from 'vue';

export default {
  name: 'analysis-mental-health',
  components: {
    MentalHealthTopStressorCauseCard,
    MentalHealthTopStressorCard,
    MentalHealthStressorsCard,
    MentalHealthWhyJoinedCard,
    MentalHealthCategoryCard
  },
  props: {
    resource: ResourceImpl,
    date: String,
    filters: Object,
    bus: Vue
  },
  data () {
    return {
      data: null,
      energyFormatter: value => {
        if (isFinite(value)) {
          return value * 10;
        }
        return 0;
      }
    };
  },
  created () {
    this.bus.$on('refresh', this.refresh);
  },
  mounted () {
    this.refresh();
  },
  destroyed () {
    this.bus.$off('refresh', this.refresh);
  },
  methods:{
    refresh () {
      if (this.resource.$has('mental_health')) {
        const params = {
          ...this.filters,
          date: this.date
        };
        this.resource.$request().$get('mental_health', params).then(res => {
          this.data = res;
        });
      }
    }
  }
};
</script>

<style scoped>

</style>
